<template>
  <span
    class="spire-autosave-indicator spire-tag spire-tag--min-content"
    :class="savingClass"
  >
    <span class="spire-autosave-indicator__icon"></span>
    <span class="spire-autosave-indicator__text">{{ savingStatus }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  isSaving: Boolean,
});

const savingStatus = computed(() => {
  return props.isSaving ? "Saving..." : "Saved";
});

const savingClass = computed(() => {
  return props.isSaving ? "spire-tag--info wait-loop" : "spire-tag--success";
});
</script>
